// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { SharedComponent } from '../../../shared/shared.component';
// import { AlertService } from '../../_services/alert.service';
// import { AuthService } from '../../_services/auth.service';
// import { AccountService } from '../../_services/domainservice/account.service';

// @Component({
//   selector: 'app-forgotpassword',
//   templateUrl: './forgotpassword.component.html',
//   styleUrls: ['./forgotpassword.component.css']
// })
// export class ForgotpasswordComponent extends SharedComponent implements OnInit {
//   forgetPasswordForm: FormGroup;
//   submitted = false;
//   //email: string = '';

//   constructor(
//     private formBuilder: FormBuilder,
//     private authService: AuthService,
//     private alertService: AlertService,
//     private spinner: NgxSpinnerService,
//     private router: Router,
//     private accountService: AccountService
//   ) {
//     super();
//   }
//   ngOnInit() {
//     this.forgetPasswordForm = this.formBuilder.group({
//       email: ['', [Validators.required, Validators.email]]
//     });
//   }

//   get f() { return this.forgetPasswordForm.controls; }

//   onSubmit() {
//     this.submitted = true;
//     this.accountService.getAccountEmail(this.getBase64Encode(this.forgetPasswordForm.value.email)).subscribe((data): void => {
//      /* for (var i = 0; i < data.length; i++) {*/
//         if (this.forgetPasswordForm.value.email === data[0].email) {
//           alert('Valid EmailID')
//         }
//         else {
//           alert('something went wrong')
//         }
//       /*}*/
//     })
//     //this.authService.forgetPassword(this.email);
//     //this.email = '';

//     //  this.submitted = true;
//     //  //this.alertService.clear();

//     //  if (this.forgetPasswordForm.invalid) {
//     //    return;
//     //  }

//     //  this.spinner.show();
//     //  this.authService.forgetPassword(this.forgetPasswordForm.value.email)
//     //    .subscribe({
//     //      next: () => {
//     //        this.alertService.success('Password reset link sent to your email');
//     //        this.router.navigate(['/login']);
//     //      },
//     //      error: (error) => {
//     //        this.alertService.error(error);
//     //        this.spinner.hide();
//     //      },
//     //      complete: () => this.spinner.hide()
//     //    });
//     //}

//   }
// }



import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../_services/domainservice/login.service';

/**
 * FORGOT PASSWORD (NEW).
 * Collects the email and asks the backend to create a PasswordReset
 * token and email a reset link (see auth-tables.sql -> PasswordReset).
 * You already have getAccountEmail() and forgotsendmailpassword();
 * wire requestPasswordReset() to insert the token + send the link.
 */
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotPasswordComponent {
step: 1 | 2 = 1;
loading = false;
errorMessage = '';
successMessage = '';

requestForm: FormGroup;
resetForm: FormGroup;

constructor(
  private readonly fb: FormBuilder,
  private readonly router: Router,
  private readonly loginService: LoginService,
) {
  this.requestForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });
  this.resetForm = this.fb.group({
    code: ['', Validators.required],
    newPassword: ['', [Validators.required, Validators.minLength(8)]],
  });
}

  get rf() { return this.requestForm.controls; }
  get sf() { return this.resetForm.controls; }

requestCode(): void {
  this.errorMessage = '';
  this.successMessage = '';
  if(this.requestForm.invalid) { return; }

this.loading = true;
const email = this.requestForm.value.email;
this.loginService.requestPasswordReset(email).subscribe({
  next: () => {
    this.loading = false;
    // The real endpoint always returns 200 and never reveals whether the account exists
    // (RequestPasswordReset's own comment: "Always 200 — never reveal whether the account
    // exists.") — so this message is intentionally non-committal, matching that behavior.
    this.successMessage = 'If an account exists for that email, a code has been sent.';
    this.step = 2;
  },
  error: () => {
    this.loading = false;
    this.errorMessage = 'Could not send the reset code. Please try again.';
  },
});
  }

resetPassword(): void {
  this.errorMessage = '';
  this.successMessage = '';
  if(this.resetForm.invalid) { return; }

this.loading = true;
const { code, newPassword } = this.resetForm.value;
const email = this.requestForm.value.email;
this.loginService.resetPassword(email, code, newPassword).subscribe({
  next: () => {
    this.loading = false;
    this.successMessage = 'Password updated. Redirecting to sign in...';
    setTimeout(() => this.router.navigate(['/login']), 1200);
  },
  error: (err: any) => {
    this.loading = false;
    const code2 = err?.error?.code;
    this.errorMessage =
      code2 === 'EXPIRED' ? 'That code has expired. Request a new one.' :
        code2 === 'TOO_MANY' ? 'Too many attempts. Request a new code.' :
          code2 === 'NOT_FOUND' ? 'No active code found. Request a new one.' :
            'Incorrect code. Please try again.';
  },
});
  }

backToRequest(): void {
  this.step = 1;
  this.errorMessage = '';
  this.successMessage = '';
}
}
